/**
 * @file app.component.ts
 * @description a root app module
 */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { register as registerSwiperElements } from 'swiper/element/bundle';

import { CoreModule } from '@core/core.module';
import { HttpInterceptorProviders } from '@core/interceptors';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '@root/environments/environment';
import { APP_INIT_PROVIDER, BrandConfigService } from '@core/services';
import { APP_CORE_CONFIG, APP_VERSION, BRAND_CONFIG } from '@core/injection-tokens';

registerSwiperElements();

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    HttpInterceptorProviders,
    APP_INIT_PROVIDER,
    { provide: APP_VERSION, useValue: `${environment.appVersion}` },
    {
      provide: APP_CORE_CONFIG,
      useValue: environment.coreConfig,
    },
    {
      provide: BRAND_CONFIG,
      useFactory: (brandConfig: BrandConfigService) => brandConfig.getBrandConfig(),
      deps: [BrandConfigService],
    },
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: { disabled: true },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
